import Widget from "../../../../lib/ui/Widget";
import { ProcessedCacheTypes } from "./ProcessedCacheTypes";
import * as fuzzysort from "fuzzysort";
import TextField from "../../../../lib/ui/controls/TextField";
import Properties from "../../widgets/Properties";
import { C } from "../../../../lib/ui/constructors";
import { CursorType } from "../../../../lib/runescape/CursorType";
import ContextMenu from "../../widgets/ContextMenu";
import { TileCoordinates } from "../../../../lib/runescape/coordinates";
var Prototype = ProcessedCacheTypes.Prototype;
var vbox = C.vbox;
var hboxl = C.hboxl;
var inlineimg = C.inlineimg;
class PreparedSearch {
    constructor(items, search_term) {
        this.prepared_items = items.map(i => {
            return { item: i, term: fuzzysort.prepare(search_term(i)) };
        });
    }
    do(term, limit = undefined) {
        let results = fuzzysort.go(term, this.prepared_items, {
            key: "term",
            all: true,
            threshold: -10000,
            limit: limit
        });
        return results.map(i => i.obj.item);
    }
}
export class PrototypeProperties extends Properties {
    constructor(prototype) {
        super();
        this.header(PrototypeProperties.renderName(prototype));
        this.named("Id", prototype.id[1].toString());
        this.named("Size", `${prototype.size.x}x${prototype.size.y}`);
        this.named("Actions", vbox(...prototype.actions.map(action => hboxl(inlineimg(CursorType.meta(action[1]).icon_url), C.space(), action[0], C.space(), `(${action[2]})`))));
    }
}
(function (PrototypeProperties) {
    var staticentity = C.staticentity;
    var npc = C.npc;
    function renderName(prototype) {
        if (Prototype.isLoc(prototype)) {
            return staticentity(prototype.name);
        }
        else {
            return npc(prototype.name);
        }
    }
    PrototypeProperties.renderName = renderName;
})(PrototypeProperties || (PrototypeProperties = {}));
export class PrototypeInstanceProperties extends PrototypeProperties {
    constructor(instance) {
        super(instance.prototype);
        this.named("Origin", TileCoordinates.toString(instance.instance.position));
        this.named("Rotation", instance.instance.rotation.toString());
    }
}
export class PrototypeExplorer extends Widget {
    constructor(prototypes, filter, click_options) {
        super();
        this.filter = filter;
        this.click_options = click_options;
        this.search_field = new TextField().setPlaceholder("Search...")
            .onPreview(term => this.update(term)).appendTo(this);
        this.result_area = c().appendTo(this)
            .css("max-height", "600px")
            .css("overflow-y", "scroll");
        this.setPrototypes(prototypes);
    }
    setPrototypes(prototypes) {
        this.index = new PreparedSearch(prototypes, p => p.name + p.actions.map(a => a[0]).join());
        this.update(this.search_field.get());
    }
    update(term) {
        const results = this.index.do(term, 200);
        this.result_area.empty();
        results.forEach(prototype => {
            new PrototypeExplorer.PrototypeSearchResult(prototype)
                .on("click", e => {
                new ContextMenu({
                    type: "submenu",
                    children: this.click_options(prototype),
                    text: () => PrototypeProperties.renderName(prototype)
                }).showFromEvent(e);
            })
                .appendTo(this.result_area);
        });
    }
}
(function (PrototypeExplorer) {
    var hboxl = C.hboxl;
    class PrototypeSearchResult extends Widget {
        constructor(prototype) {
            super();
            this.addClass("ctr-clickable");
            this.append(hboxl(PrototypeProperties.renderName(prototype), C.space(), `(${prototype.size.x}x${prototype.size.y})`));
            this.addTippy(new PrototypeProperties(prototype), {
                placement: "bottom",
            });
        }
    }
    PrototypeExplorer.PrototypeSearchResult = PrototypeSearchResult;
})(PrototypeExplorer || (PrototypeExplorer = {}));
